"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.showToast = exports.showSuccessToast = exports.showWarningToast = exports.showInfoToast = exports.showErrorToast = exports.removeToast = exports.REMOVE_TOAST = exports.addToast = exports.ADD_TOAST = void 0;

var _createAction = require("../../skybase-core/base/create-action");

var _getActionName = require("../../skybase-core/utils/get-action-name");

var _constants = require("./constants");

var _utils = require("./utils");

var DEFAULT = _constants.toastTypes.DEFAULT,
    ERROR = _constants.toastTypes.ERROR,
    INFO = _constants.toastTypes.INFO,
    SUCCESS = _constants.toastTypes.SUCCESS,
    WARNING = _constants.toastTypes.WARNING;
var ADD_TOAST = (0, _getActionName.getActionName)('ADD_TOAST');
exports.ADD_TOAST = ADD_TOAST;

var addToast = function addToast(toast) {
  return (0, _createAction.createAction)(ADD_TOAST, {
    toast: toast
  });
};

exports.addToast = addToast;
var REMOVE_TOAST = (0, _getActionName.getActionName)('REMOVE_TOAST');
exports.REMOVE_TOAST = REMOVE_TOAST;

var removeToast = function removeToast(id) {
  return (0, _createAction.createAction)(REMOVE_TOAST, {
    id: id
  });
};
/**
 * Pushed a new Error typed toast to the state with a provided configuration.
 * @param message - Message that appears on the toast.
 * @param config - Toast specific configurations. For all properties please visit the documentation and look for Toast props.
 * @returns {Object}
 */


exports.removeToast = removeToast;

var showErrorToast = function showErrorToast(message, config) {
  return function (dispatch) {
    var toast = (0, _utils.createToast)(message, ERROR, config);
    dispatch(addToast(toast));
  };
};
/**
 * Pushed a new Info typed toast to the state with a provided configuration.
 * @param message - Message that appears on the toast.
 * @param config - Toast specific configurations. For all properties please visit the documentation and look for Toast props.
 * @returns {Object}
 */


exports.showErrorToast = showErrorToast;

var showInfoToast = function showInfoToast(message, config) {
  return function (dispatch) {
    var toast = (0, _utils.createToast)(message, INFO, config);
    dispatch(addToast(toast));
  };
};
/**
 * Pushed a new Warning typed toast to the state with a provided configuration.
 * @param message - Message that appears on the toast.
 * @param config - Toast specific configurations. For all properties please visit the documentation and look for Toast props.
 * @returns {Object}
 */


exports.showInfoToast = showInfoToast;

var showWarningToast = function showWarningToast(message, config) {
  return function (dispatch) {
    var toast = (0, _utils.createToast)(message, WARNING, config);
    dispatch(addToast(toast));
  };
};
/**
 * Pushed a new Success typed toast to the state with a provided configuration.
 * @param message - Message that appears on the toast.
 * @param config - Toast specific configurations. For all properties please visit the documentation and look for Toast props.
 * @returns {Object}
 */


exports.showWarningToast = showWarningToast;

var showSuccessToast = function showSuccessToast(message, config) {
  return function (dispatch) {
    var toast = (0, _utils.createToast)(message, SUCCESS, config);
    dispatch(addToast(toast));
  };
};
/**
 * Pushed a new Default typed toast to the state with a provided configuration.
 * @param message - Message that appears on the toast.
 * @param config - Toast specific configurations. For all properties please visit the documentation and look for Toast props.
 * @returns {Object}
 */


exports.showSuccessToast = showSuccessToast;

var showToast = function showToast(message, config) {
  return function (dispatch) {
    var toast = (0, _utils.createToast)(message, DEFAULT, config);
    dispatch(addToast(toast));
  };
};

exports.showToast = showToast;
//# sourceMappingURL=actions.js.map